var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geo-chart-clinical",staticStyle:{"width":"100%","height":"500px"}},[_c('div',{ref:"geoChartClinical",staticStyle:{"height":"500px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }